import React, { useMemo } from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import { dateFormate, indianTimeZone } from '../../../utils/helper.jsx';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const ProposalsSection = ({
  proposals,
  selectedAccount,
  selectedOrganisation
}: {
  proposals: any[],
  selectedAccount: any | null,
    selectedOrganisation: any | null,
}) => {
  const navigate = useNavigate();

  const campaignStateLabels: { [key: string]: string } = {
    PTC: 'Converted',
    PR: 'Requested',
    PF: 'Finalized',
    POH: 'On-Hold',
    PNC: 'Declined',
  };


  const proposalColumns = useMemo(() => [
    {
      accessorKey: 'name',
      header: 'Business Service Name',
      size: 50,
      enableSorting: false,
      Cell: ({ row }) => {
        const { name, proposal_id } = row.original;
        return (
          <Link
            to={`/r/records/v1`}
            style={{
              color: 'blue',
              cursor: 'pointer',
              textDecoration: 'none',
            }}
          >
            {name}
          </Link>
        );
      },
    },
    { accessorKey: 'created_by', header: 'Created By', size: 50, enableSorting: false },
    {
      accessorKey: 'created_at', header: 'Created Date', Cell: ({ row }) => (
        dateFormate(indianTimeZone(row.original.created_at), "DD-MM-YYYY hh:mm A")
      ), size: 50, enableSorting: false
    },
    { accessorKey: 'updated_by', header: 'Edited By', size: 50, enableSorting: false },
    {
      accessorKey: 'updated_at', header: 'Last Edited', Cell: ({ row }) => (
        dateFormate(indianTimeZone(row.original.updated_at), "DD-MM-YYYY hh:mm A")
      ), size: 50, enableSorting: false
    },
    {
      accessorKey: 'campaign_state',
      header: 'Status',
      Cell: ({ row }) => (
        <Button
          variant="text"
          color="primary"
          size='small'
          onClick={() => navigate(`/r/management/proposal-summary/${row.original.proposal_id}`)}
        >
          {campaignStateLabels[row.original.campaign_state]}
        </Button>
      ),
      size: 50, enableSorting: false
    },
    // { accessorKey: 'name', header: 'Map View', Cell: () => <Button size='small' variant="text" color="primary">View on Map/Grid</Button>, size: 50 },
    // { accessorKey: 'name', header: 'Upload', Cell: () => <Button  size='small' variant="text" color="primary">Upload</Button>, size: 50 },
    // {
    //   accessorKey: 'name',
    //   header: 'View Image',
    //   Cell: ({ row }) => (
    //     <Button
    //       variant="text"
    //       color="primary"
    //       size='small'
    //       onClick={() => handleViewImage(row.original)}
    //     >
    //       View Images
    //     </Button>
    //   ),
    //   size: 50
    // },

  ], []);

  const handleNewProposalClick = () => {
    navigate('/r/management/create-campaign', {
      state: {
        selectedAccount: selectedAccount,
        organisationId: selectedOrganisation?.organisation_id,
      },
    });

  };

  const handleViewImage = (proposal: any) => {
    navigate('/r/management/opsExecutionPlan', { state: { proposal } });
  };


  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h6" color="dark">Business Service</Typography>
        <Tooltip title={selectedAccount ? "Add New Business Service" : "Please select an Account"}>
          <span>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleNewProposalClick}
              disabled={!selectedAccount}
            >
              New Business Service
            </Button>
          </span>
        </Tooltip>

      </Box>
      <CommonTable
        columns={proposalColumns}
        data={proposals}
        enablePagination={false}
      />
    </>
  );
};

export default ProposalsSection;
